import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface AggregatedIncentiveCampaignsSpendProps extends BaseTemplateProps {}

export const AggregatedIncentiveCampaignsSpend: TemplateDefinition<AggregatedIncentiveCampaignsSpendProps> =
  {
    renderParams: () => ({
      messageKey: 'notificationsDomain.templates.aggregatedIncentiveCampaignsSpend',
      values: {},
    }),
  }
